export const CategoryDataFragment = `
     id
    name
    image_path
    parent_id
`
